import { IconButton } from "@/components/ui/icon-button"
import { DiscArrowIcon } from "@/components/ui/icons"
import { tv, type VariantProps } from "@/lib/utils/tv"

// The round previous/next control of the rails, the promo cards and the product gallery.
const arrowDisc = tv({
  base: "border-0",
  variants: {
    tone: {
      brand: "bg-brand text-fg-inverted hover:bg-brand-hover",
      inverse: "bg-surface text-fg-brand hover:bg-surface-subtle",
      // The gallery's white disc lifts off the photo and keeps its colour at either end.
      raised: "bg-surface shadow-disc text-fg-brand hover:bg-surface disabled:opacity-100",
    },
    size: {
      rail: "size-7.5 @3xl:size-12.5",
      stage: "size-12.5",
    },
  },
  defaultVariants: { tone: "brand", size: "rail" },
})

interface ArrowDiscProps extends VariantProps<typeof arrowDisc> {
  direction: "previous" | "next"
  "aria-label": string
  onClick: () => void
  disabled?: boolean
  className?: string
}

export const ArrowDisc = ({ direction, tone, size = "rail", className, ...rest }: ArrowDiscProps) => (
  <IconButton
    {...rest}
    icon={<DiscArrowIcon size={size === "rail" ? 30 : 50} className={`${direction === "previous" ? "rotate-180" : ""} ${size === "rail" ? "@3xl:size-12.5" : ""}`} />}
    className={arrowDisc({ tone, size, className })}
  />
)
